<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/05_List"><em class="italic">List of Plates</em></a></h2>
<h2 class="toc"><a href="#/xhtml/06_Preface"><em class="italic">Preface</em></a></h2>
<h2 class="toc"><a href="#/xhtml/07_Acknowledgements"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toc"><a href="#/xhtml/08_Comments"><em class="italic">Comments on the Present Version of John Smith’s Work</em></a></h2>
<h2 class="tocc"><a href="#/xhtml/09_Chapter01"><span class="tocc"><span class="bold">Chapter 1</span></span> Ordered to Belgium</a></h2>
<h2 class="tocc"><span href="#/xhtml/10_Chapter02" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 2</span></span> Marching to Join the Army</span></h2>
<h2 class="tocc"><span href="#/xhtml/11_Chapter03" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 3</span></span> Preparations for War</span></h2>
<h2 class="tocc"><span href="#/xhtml/12_Chapter04" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 4</span></span> War Clouds Gather</span></h2>
<h2 class="tocc"><span href="#/xhtml/13_Chapter05" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 5</span></span> Retreat</span></h2>
<h2 class="tocc"><span href="#/xhtml/14_Chapter06" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 6</span></span> The Day of Waterloo</span></h2>
<h2 class="tocc"><span href="#/xhtml/15_Chapter07" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 7</span></span> 19 June</span></h2>
<h2 class="tocc"><span href="#/xhtml/16_Chapter08" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 8</span></span> Mont St Jean Farm</span></h2>
<h2 class="tocc"><span href="#/xhtml/17_Chapter09" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 9</span></span> March to Paris</span></h2>
<h2 class="tocc"><span href="#/xhtml/18_Chapter10" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 10</span></span> Paris in Peace</span></h2>
<h2 class="tocc"><span href="#/xhtml/19_Chapter11" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 11</span></span> Normandy</span></h2>
<h2 class="tocc"><span href="#/xhtml/20_Chapter12" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 12</span></span> Neufchatel-en-Bray</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1fa7d05a